import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../../lib/i18n";
import { ASSETS } from "../../lib/data";

export const BlogHeader = ({ backLabel }) => {
  const { toggle, lang } = useLang();
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="sticky top-0 z-50 bg-black/70 backdrop-blur-xl border-b border-white/10"
    >
      <nav className="max-w-[1400px] mx-auto flex items-center justify-between px-5 md:px-10 h-[72px]">
        <Link to="/" className="flex items-center gap-2" data-testid="blog-logo">
          <img src={ASSETS.logo} alt="Gesung" className="h-8 w-8 rounded-md object-cover" />
          <span className="font-display font-extrabold text-lg tracking-tight text-offwhite">GESUNG</span>
        </Link>
        <div className="flex items-center gap-4">
          <button
            onClick={toggle}
            data-testid="blog-lang-toggle"
            className="text-xs font-semibold border border-white/20 rounded-full px-3 py-1.5 text-white/80 hover:border-lime2 hover:text-lime2 transition-colors"
          >
            {lang === "en" ? "EN / FR" : "FR / EN"}
          </button>
          <Link to="/blog" className="hidden sm:inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-lime2 transition-colors" data-testid="blog-back">
            <ArrowLeft size={15} /> {backLabel}
          </Link>
        </div>
      </nav>
    </motion.header>
  );
};
